import React, { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation.js';
import { brandText } from './BrandText.jsx';
import Footer from './Footer.jsx';
import { applyPageSeo } from '../utils/seo.js';

// A legal text page from its per-language file (seo, hero, sections, contact, lastUpdated): the privacy statement
// (D-HP-SITE-029) and the AI transparency page (D-HP-SITE-031) share this one layout.
const LegalTextPage = ({ pageKey, pageId }) => {
  const { t, currentLang } = useTranslation(pageKey);

  useEffect(() => {
    applyPageSeo({ ...t.seo, pageId }, currentLang);
  }, [t.seo, currentLang, pageId]);

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main">
        <section className="site-hero site-hero--single">
          <div className="site-hero__copy">
            <h1 className="site-title">{t.hero?.title}</h1>
            <p className="site-lead">{t.hero?.subtitle}</p>
          </div>
        </section>

        {t.sections?.map((section, index) => (
          <section className="legal-section" key={index}>
            <h2 className="legal-section__title">{section.title}</h2>
            <div className="legal-section__body">
              {section.paragraphs?.map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex}>{brandText(paragraph)}</p>
              ))}
            </div>
          </section>
        ))}

        <section className="legal-section">
          <h2 className="legal-section__title">{t.contact?.title}</h2>
          <div className="legal-section__body">
            <p>{t.contact?.description}</p>
            <p><a href={`mailto:${t.contact?.email}`}>{brandText(t.contact?.email)}</a></p>
          </div>
        </section>

        <p className="legal-note">{t.lastUpdated}</p>
      </main>

      <Footer />
    </div>
  );
};

export default LegalTextPage;
